import { _T } from '../globals';

export default {
    methods: {
        _T(value, params = []) {
            return _T(value, params);
        }
    }
};
